<template>
  <ol class="black--text body-2">
    <li>Masih aktif di dalam Dapodik dalam semester berjalan (belum purna tugas)</li>
    <li>Memiliki minat dan terlibat dalam pengembangan kurikulum di sekolah</li>
    <li>Memiliki ketertarikan pada pengembangan kompetensi guru dan kualitas pembelajaran di sekolah</li>
    <li>Terbiasa menggunakan platform belajar daring (google meet, zoom, dan aplikasi belajar daring lainnya)</li>
    <li>
      Memiliki laptop/ponsel untuk digunakan pada saat pelatihan (untuk ponsel dengan sistem android minimal versi 8)
    </li>
    <li>
      Jumlah perwakilan yang diajukan:
      <ul>
        <li>1 Waka Kurikulum</li>
        <li>1 Pengawas</li>
        <li>1 Guru BK</li>
        <li>2 Guru Program Keahlian Unggulan</li>
        <li>1 Guru Umum</li>
        <li>1 Guru Cadangan (Program Keahlian / Umum)</li>
      </ul>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'InstruksiSmk',
};
</script>

<style scoped></style>
